<template>
  <div v-frag>
    <CardIeaAppMain>
      <v-container fluid class="pa-0 mt-4">
        <v-row justify="center" align="center">
          <v-col cols="12" md="10" lg="8" class="text-center">
            
            
            <!-- BAJA ALERT -->
            <v-alert
              v-if="user.borrado == '1' || user.alumno_mora"
              type="error"
              prominent
              border="left"
              class="rounded-xl mb-6 elevation-4 text-left"
              style="background: linear-gradient(135deg, #FF5252, #D32F2F) !important; border-color: rgba(255,255,255,0.3) !important;"
            >
              <template v-slot:prepend>
                <v-icon large color="white">mdi-account-off-outline</v-icon>
              </template>
              <div class="font-weight-bold text-h6 mb-1 white--text">
                Situación Administrativa Irregular
              </div>
              <div class="white--text opacity-90">
                Tu usuario se encuentra actualmente en estado de <strong>baja</strong> o con <strong>mora administrativa</strong>. Por este motivo, el acceso a los módulos académicos ha sido restringido. Por favor, regulariza tu situación en la sección de <strong>Pagos</strong> o contacta con administración.
              </div>
              <template v-slot:append>
                <v-btn
                  dark
                  text
                  class="font-weight-bold"
                  @click="$router.push({name: 'PaymentCurso'})"
                >
                  Ir a Pagar
                </v-btn>
              </template>
            </v-alert>

            <!-- HERO SECTION -->
            <div class="bce-hero-container mb-10">
              <v-img
                :src="require('../assets/students.jpg')"
                class="bce-hero-image rounded-xl elevation-12"
                aspect-ratio="2.2"
                max-height="450"
                cover
              >
                <!-- OVERLAY TEXT -->
                <div class="bce-hero-overlay d-flex flex-column align-center justify-center">
                  <h1 class="white--text text-h3 font-weight-bold mb-2">¡Bienvenido/a!</h1>
                  <p class="white--text text-h6 font-weight-light">Nos alegra verte de nuevo en el campus.</p>
                </div>
              </v-img>
            </div>

            <!-- IMPORTANT NOTICE / DASHBOARD CONTENT -->
            <v-card class="rounded-xl pa-8 bce-dashboard-card mb-6" elevation="2">
              <div class="d-flex align-center mb-6">
                <v-icon color="#E50050" class="mr-3">mdi-information-outline</v-icon>
                <h2 class="text-h5 font-weight-bold grey--text text--darken-3">Aviso Importante</h2>
              </div>
              <p class="grey--text text--darken-1 text-left line-height-relaxed">
                Recuerda mantener tus datos actualizados y revisar la sección de notificaciones para estar al tanto de las últimas novedades académicas y administrativas.
              </p>
            </v-card>

          </v-col>
        </v-row>
      </v-container>
    </CardIeaAppMain>

    <!-- MODAL INICIAL (DERECHOS / MEDALLAS) -->
    <v-dialog v-model="apareceModalMedallaIncial" width="auto">
      <v-card class="pa-4 rounded-xl">
        <v-card-title class="headline font-weight-bold justify-center">
          ¡Felicidades!
        </v-card-title>
        <v-card-text class="mt-3 text-center d-flex flex-column justify-center align-center">
          Has ganado el siguiente reconocimiento por haber ingresado por primera vez a nuestra plataforma
          <v-img
            class="mt-6 bce-medal-anim"
            width="150"
            contain
            :src="require('../assets/inicial.png')"
          ></v-img>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="#E50050"
            block
            large
            dark
            class="rounded-lg"
            @click="apareceModalMedallaIncial = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CardIeaAppMain from "../components/CardIeaAppMain";
import moment from "moment";
moment.locale("es");

export default {
  name: "Home",
  components: {
    CardIeaAppMain,
  },
  data: () => ({
    tituloNovedades: "",
    descripcionNovedades: "",
    sendvalidation: false,
    documentosAlumno: [],
    waiting: true,
    docsPend: 0,
    materiaFaltantes: [],
    dialog_pago_atrasado: false,
    posicionRanking: 0,
    today: moment().format("YYYY-MM-DD"),
    showButtonClock: false,
    apareceModalMedallaIncial: false,
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    primeroIngreso() {
      return this.$store.getters.primeroIngreso;
    },
    apareceModalInicial() {
      return this.$store.getters.apareceModalInicial;
    },
  },
  mounted() {
    if (this.user && this.user.tipoUsuario === "alumno") {
      this.novedadesList();
      this.registerAccess();
      this.documentosRequeridos(this.user.IDStB);

      if (this.primeroIngreso && !this.apareceModalInicial) {
        this.apareceModalMedallaIncial = true;
        this.$store.commit("apareceModalInicial", true);
      }
    }
  },
  methods: {
    async novedadesList() {
      try {
        const res = await this.$API.get({ url: "notificaciones/index", data: {} });
        if (res && res.length > 0) {
          this.tituloNovedades = res[res.length - 1].titulo.toUpperCase();
          this.descripcionNovedades = res[res.length - 1].descripcion;
        }
      } catch (e) { console.error(e); }
    },
    async registerAccess() {
      try {
        await this.$API.post({
          url: "alumno/register-access",
          data: { tipo: "web" },
        });
      } catch (e) { console.error(e); }
    },
    async documentosRequeridos(alumno) {
      try {
        const res = await this.$API.get({
          url: "documentos/requeridos/" + alumno,
          data: {},
        });
        this.waiting = false;
        this.documentosAlumno = res;
      } catch (e) { this.waiting = false; }
    },
  },
};
</script>

<style scoped>
.bce-hero-container {
  overflow: hidden;
  border: 4px solid #ffffff;
  border-radius: 28px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
}

.bce-hero-image {
  transition: transform 0.5s ease;
}

.bce-hero-overlay {
  background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 100%);
  height: 100%;
  padding-bottom: 20px;
}

.bce-dashboard-card {
  border: 1px solid rgba(0,0,0,0.05);
  background: white;
}

.line-height-relaxed {
  line-height: 1.8;
}

.bce-medal-anim {
  animation: bounce 2s infinite ease-in-out;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

@media screen and (max-width: 600px) {
  .text-h3 {
    font-size: 2rem !important;
  }
}
</style>
